import Modal from 'react-bootstrap/Modal'
import {Form, Formik} from "formik";
import {TextField} from "../../components/common/TextField/TextField";
import React, {useEffect, useState} from "react";
import {OptionList} from "../../components/common/OptionList/OptionList";
import {Col, Row} from "react-bootstrap";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {DateRangePickerComponent, TimePickerComponent} from "@syncfusion/ej2-react-calendars";
import dateFormat from "dateformat";
import {dateFormatToDb, filesTo} from "../../api/api";
import ShowNotification from "../../components/common/Notification/ShowNotification";

const EditDataModal = ({show, setIsEditProductType,deleteProductTypeTh,productType, productTypes, updateProductTypeTh, productTypeId,...props}) => {
    let product = productTypes.filter((item) =>item.id == parseInt(productTypeId))[0]

    let [showModal, setShowModal] =useState(show)
    let [showDeleteModal, setShowDeleteModal] =useState(show)
    const handleClose=()=>{
        setIsEditProductType(false)
    }    
    const [submitClicked,setSubmitClicked]=useState(false)
    let [status, setStatus]=useState(product.status)
    
    useEffect(()=>{
        if(show) setShowModal(true)
        else setShowModal(false)

        console.log(product.name)
    },[show])

    const DeleteProductType=()=>{
        setShowDeleteModal(true)
    }

    let statList=[
        {id:0, name: 'Deactive',status:1},
        {id:1, name: 'Active',status:1}
    ]

    let productTypeInstance={
        id: 1,      
        status: 1,
        name: "",
    }
    debugger
    return(<Formik
        initialValues={{
            id: product.id ? product.id : '',
            name: product.name ? product.name: '' ,        
            status: status ? status :'',          
        }}
        onSubmit={(formValues)=> {
            if(submitClicked) {
                // console.log(formValues);
                productTypeInstance.id = formValues.id
                productTypeInstance.name = formValues.name

                productTypeInstance.status = parseInt(formValues.status)
                console.log(productTypeInstance)
                updateProductTypeTh(productTypeInstance);
                setIsEditProductType(false)
            }
        }}
    >
        {props => (<>
                <Modal size="sm" show={showDeleteModal}>
                    <Modal.Body closeButton>
                        <Modal.Title>Silinməni təstiq edin</Modal.Title>
                    </Modal.Body>
                    <Modal.Footer className='text-center'>
                        <button type="reset"
                                className="btn btn-danger mr-3"
                                onClick={()=>{
                                    deleteProductTypeTh(product.id)
                                    setIsEditProductType(false)
                                    setShowDeleteModal(false)
                                }}
                                data-dismiss="modal">Mehsulu sil</button>
                        <button type="submit"
                                onClick={()=>{
                                    setShowDeleteModal(false)
                                    setIsEditProductType(false)
                                }}
                                className="btn btn-primary">Geri Qayit</button>
                    </Modal.Footer>
                </Modal>
            <Modal size="md" show={showModal} onHide={handleClose} autoFocus="true" restoreFocus="true">
                <Modal.Header closeButton>
                    <Modal.Title>Mehsul növü redaktə et</Modal.Title>
                </Modal.Header>
                <Form >
                    <Modal.Body>
                        <TextField label="Mehsul növü Adı"
                                   name="name"
                                   type="text"
                                   enableLabel='true'
                        />
                        <Row>
                               <Col>
                                   <OptionList
                                       label="Status"
                                       data={statList}
                                       name='status'
                                       selectedItem={status}
                                       setData={setStatus}
                                   />
                               </Col>
                        </Row>

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="reset"
                                className="btn btn-danger mr-3"
                                onClick={
                                    ()=>{
                                        setShowModal(false)
                                        setShowDeleteModal(true)
                                    }
                                }
                                data-dismiss="modal">Mehsulu sil</button>
                        <button type="submit"
                                onClick={()=>{
                                    setSubmitClicked(true)
                                }}
                                className="btn btn-primary">Yadda saxla</button>
                    </Modal.Footer>
                </Form>
            </Modal>
            </>
        )}
    </Formik>)
};

export default EditDataModal;
